import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { UserRoleEnum } from '../models/enums/user-role.enums';
import { AuthService } from '../services/auth.service';
import { LocalStorageService } from '../services/local-storage.service';
import { LocalStorageEnum } from '../models/enums/local-storage.enum';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  constructor(
    private _localStorageService: LocalStorageService,
    private authService: AuthService,
    private router: Router
  ) {}

  get getUseManagementFee(): any {
    return this._localStorageService.get(LocalStorageEnum.use_management_status);
  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.checkAccess(childRoute, state);
  }

  private checkAccess(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    if (!this.authService.isAuth || this.authService.tokenExpired) {
      this.router.navigate(['/login']);
      return false;
    }
    if (state.url.startsWith('/management-fee') && this.getUseManagementFee !== 'true') {
      this.router.navigate(['/dashboard']);
      return false;
    }
    if (route.routeConfig?.path === 'management-fees' && this.getUseManagementFee !== 'true') {
      this.router.navigate([state.url.replace(/management-fees$/, 'overview')]);
      return false;
    }
    return true;
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (!this.authService.isAuth || this.authService.tokenExpired) {
      this.router.navigate(['/login']);
      return false;
    } else if (!next.data.roles || (next.data.roles as string[])?.includes(this.authService.userRole)) {
      return true;
    } else if (this.authService.userRole == UserRoleEnum.super_admin) {
      if (state.url == '/dashboard' || state.url == '/organizations' || state.url == '/managers') {
        return true;
      } else {
        this.router.navigate(['/dashboard']);
        return false;
      }
    } else if (this.authService.userRole == UserRoleEnum.agent) {
      if (state.url == '/properties' || state.url == '/clients') {
        return true;
      } else {
        this.router.navigate(['/properties']);
        return false;
      }
      // TODO: Solve the router caused crash error if some routes are not accessible by certain user roles
    } else {
      this.router.navigate(['/']);
      return false;
    }
  }
}
